// These fields should be editable by user
export const formFields = [
	'annualOperatingHours(h)',
	'estimatedMachineLifetime',
	'tramming(%)',
	'undercarriageLifetime(h)',
	'labourCostPerHourForMaintenance',
	'averageFuelPrice($/l)',
	'production,(Tonnes/hour)',
	'revenuePerTonne($)',
];
